// extracted by mini-css-extract-plugin
module.exports = {"toggle":"EvaluationToggle_toggle__36W2B"};